








































































































































































import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { IGameItemForSaleByGala } from '~/store/games/types';
import ProductSupply from '~/components/Store/ProductSupply.vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
import TextOutput from '~/mixins/TextOutput';
import CountdownTimer from '~/components/Promotions/CountdownTimer.vue';

@Component({ components: { ProductSupply, CountdownTimer } })
export default class StoreItemCard extends Mixins(TextOutput) {
  @Prop(Object) readonly item!: IGameItemForSaleByGala;
  @Prop(String) readonly itemLink!: string;

  comingSoon = false;

  coinIcon(coin: string) {
    return `https://static.gala.games/token-icons/${(coin || '')
      .replace(/CC-[A-Z]+$/, 'CC')
      .replace(/\[ETH\]|\[GC\]/g, '') ||
      this.price.symbol.replace(/\[ETH\]|\[GC\]/g, '')}-icon.png`;
  }

  formattedDiscount(discount: number) {
    return this.$numeral(discount, '0%');
  }

  get rarityIcon() {
    return this.item.rarity ? this.item.rarity.icon : undefined;
  }

  get price() {
    return this.item.prices
      ? this.item.prices[0]
      : { price: '0', basePrice: '0', symbol: 'GALA' };
  }

  get discount() {
    const discountAmount = 1 - +this.price.price / +this.price.basePrice;
    return Math.max(discountAmount, 0);
  }

  get soldOut() {
    return this.item.qtyLeft <= 0;
  }

  get completelySoldOut() {
    if (this.item.tiers) {
      return (
        this.item.currentTier === this.item.tiers.length &&
        this.item.qtyLeft === 0
      );
    }

    return this.item.qtyLeft === 0;
  }

  get tierSoldOut() {
    if (this.item.tiers) {
      return (
        this.item.currentTier !== this.item.tiers.length &&
        this.item.qtyLeft === 0
      );
    }

    return false;
  }

  get rarityData() {
    return this.item ? this.item.rarity : undefined;
  }

  getPriceFormatString(price: string, symbol: string) {
    const highPrice = +price >= 1000000;
    const lowPrice = +price < 1;
    let baseString = '0,0';

    if (symbol !== 'GALA' || highPrice || lowPrice) {
      baseString += '[.]0[00]';
    }
    if (highPrice) {
      baseString += ' a';
    }

    return baseString;
  }
}
